module.exports = __webpack_public_path__ + "static/media/avondale.c9084c5f.png";